export const STRATEGY_TABLE_TITLES = [
  "Strategy Name",
  "Top Offers (%)",
  "New Offer (%)",
  "Old Winners (%)",
  "",
];
export const STRATEGY_TABLE_TITLE_WIDTHS = ["44%", "13%", "13%", "13%", "17%"];
export const STRATEGY_TABLE_TITLE_SORT = [
  { sorting: true, active: false },
  {
    sorting: true,
    active: false,
  },
  { sorting: true, active: false },
  { sorting: true, active: false },
  { sorting: false, active: false },
];

export const SMS_LIST_TABLE_TITLES = [
  "List Name & Status",
  "Daily Slot",
  "Strategy",
  "Tag",
  "",
];
export const SMS_LIST_TABLE_TITLE_WIDTHS = [
  "29.68%",
  "9%",
  "18.26%",
  "32.5%",
  "10.56%",
];
export const SMS_LIST_TABLE_TITLE_SORT = [
  { sorting: true, active: false },
  {
    sorting: true,
    active: false,
  },
  { sorting: false, active: false },
  { sorting: false, active: false },
  { sorting: false, active: false },
];

export const EMAIL_LIST_TABLE_TITLES = [
  "List Name",
  "Segment",
  "Daily Slot",
  "Strategy",
  "Tag",
  "IP Reputation",
  "Domain Reputation",
  "",
];
export const EMAIL_LIST_TABLE_TITLE_WIDTHS = [
  "32%",
  "11%",
  "8%",
  "13%",
  "6%",
  "10%",
  "10%",
  "10%",
];
export const EMAIL_LIST_TABLE_TITLE_SORT = [
  { sorting: true, active: false },
  {
    sorting: true,
    active: false,
  },
  { sorting: true, active: false },
  { sorting: false, active: false },
  { sorting: false, active: false },
  {
    sorting: false,
    active: false,
  },
  { sorting: false, active: false },
];

export const OFFERS_TABLE_TITLES = [
  "Offer Name",
  "Revenue",
  "Creative",
  "Lists",
  "Score",
  "Email Score",
  "SMS Score",
  "",
];
export const OFFERS_TABLE_TITLE_WIDTHS = [
  "20%",
  "10%",
  "12%",
  "10%",
  "9%",
  "10%",
  "9%",
  "20%",
];
export const OFFERS_TABLE_TITLE_SORT = [
  { sorting: true, active: false }, // Offer Name
  { sorting: true, active: false }, // Revenue
  { sorting: false, active: false }, // Creative (API does not support)
  { sorting: false, active: false }, // Lists (API does not support)
  { sorting: true, active: false }, // Score
  { sorting: true, active: false }, // Email Score
  { sorting: true, active: false }, // SMS Score
  { sorting: false, active: false }, // Actions
];

export const TOP_OFFERS_TABLE_TITLES = ["Offer Name", "Total Revenue", "Score"];
export const TOP_OFFERS_TABLE_TITLE_WIDTHS = ["37.8%", "37.8%", "24.4%"];
export const TOP_OFFERS_TABLE_TITLE_SORT = [false, false, false];

export const PUBLIC_TOP_OFFERS_TABLE_TITLES = [
  "#",
  "Offer Name",
  "Sends",
  "Score",
  "",
];
export const PUBLIC_TOP_OFFERS_TABLE_TITLE_WIDTHS = [
  "6%",
  "60%",
  "14%",
  "14%",
  "6%",
];

export const PUBLIC_TOP_CREATIVES_TABLE_TITLES = [
  "Creative Name",
  "Sends",
  "Score",
];
export const PUBLIC_TOP_CREATIVES_TABLE_TITLE_WIDTHS = ["66%", "17%", "17%"];

export const TOP_SMS_EMAIL_TABLE_TITLES = [
  "List Name",
  "Revenue (This / Last Week)",
];
export const TOP_SMS_EMAIL_TABLE_TITLE_WIDTHS = ["50%", "50%"];
export const TOP_SMS_EMAIL_TABLE_TITLE_SORT = [false, false];

export const TAG_TABLE_TITLES = ["Tag Name", ""];
export const TAG_TABLE_TITLE_WIDTHS = ["80%", "20%"];
export const TAG_TABLE_TITLE_SORT = [
  { sorting: true, active: false },
  {
    sorting: false,
    active: false,
  },
];

export const SMS_PRICING_TABLE_TITLES = ["Cost/Msg", "Created", "Notes", ""];
export const SMS_PRICING_TABLE_TITLE_WIDTHS = ["20%", "20%", "45%", "15%"];
export const SMS_PRICING_TABLE_TITLE_SORT = [
  { sorting: false, active: false },
  { sorting: false, active: false },
  { sorting: false, active: false },
  { sorting: false, active: false },
];

export const STATUS_LIST = [
  { id: "CREATED", name: "Created" },
  { id: "SCHEDULED", name: "Scheduled" },
  {
    id: "DONE",
    name: "Done",
  },
];

export const REPUTATION_LIST = [
  { id: "BAD", name: "Bad" },
  { id: "LOW", name: "Low" },
  {
    id: "MEDIUM",
    name: "Medium",
  },
  { id: "HIGH", name: "High" },
];

export const OFFER_PROBLEMSTABLE_TITLES = ["Score & Offer Name", "Problem"];
export const OFFER_PROBLEMS_TABLE_TITLE_WIDTHS = ["38%", "60%"];
export const OFFER_PROBLEMS_TABLE_TITLE_SORT = [
  { sorting: true, active: false },
  { sorting: true, active: false },
];

export const OFFER_DETAILS_SMS_CREATIVE_TITLES = [
  "Name",
  "Message",
  "Score",
  "Revenue",
  "",
];
export const OFFER_DETAILS_SMS_CREATIVE_TABLE_TITLE_WIDTHS = [
  "37%",
  "26%",
  "12%",
  "17%",
  "8%",
];
export const OFFER_DETAILS_SMS_CREATIVE_TABLE_TITLE_SORT = [
  { sorting: true, active: false },
  { sorting: false, active: false },
  { sorting: false, active: false },
  { sorting: false, active: false },
  { sorting: false, active: false },
];

export const OFFER_DETAILS_EMAIL_CREATIVE_TITLES = [
  "Name",
  "Creative Note",
  "Score",
  "Revenue",
  "",
];
export const OFFER_DETAILS_EMAIL_CREATIVE_TABLE_TITLE_WIDTHS = [
  "37%",
  "26%",
  "12%",
  "17%",
  "8%",
];
export const OFFER_DETAILS_EMAIL_CREATIVE_TABLE_TITLE_SORT = [
  { sorting: true, active: false },
  { sorting: false, active: false },
  { sorting: false, active: false },
  { sorting: false, active: false },
  { sorting: false, active: false },
];

export const OFFER_DETAILS_LISTS_TITLES = ["Name", "Offer Score", "Revenue"];
export const OFFER_DETAILS_LISTS_TABLE_TITLE_WIDTHS = ["40%", "14%", "46%"];
export const OFFER_DETAILS_LISTS_TABLE_TITLE_SORT = [
  { sorting: true, active: false },
  { sorting: false, active: false },
  { sorting: false, active: false },
];

export const CREATIVES_TABLE_TITLES = [
  "Creative Name",
  "Revenue",
  "Score",
  "Sends",
  "Offer",
  "Last Used",
  "",
];
export const CREATIVES_TABLE_TITLE_WIDTHS = [
  "36%",
  "7%",
  "8%",
  "8%",
  "20%",
  "11%",
  "10%",
];
export const CREATIVES_TABLE_TITLE_SORT = [
  { sorting: true, active: false }, // Creative Name
  { sorting: true, active: false }, // Revenue
  { sorting: true, active: false }, // Score
  { sorting: true, active: false }, // Sends
  { sorting: true, active: false }, // Offer
  { sorting: true, active: false }, // Last Used
  { sorting: false, active: false }, // Actions
];
